import { login } from '@ax/service';
import { LoginInput } from '@ax/service/src/gwp-interface';
import { useMutation } from '@tanstack/react-query';

export function useLogin() {
  const loginMutation = useMutation({
    mutationKey: ['login'],
    mutationFn: (loginDataInput: LoginInput) => login(loginDataInput),
    onError: (error: any) => {
      console.log(error);
    },
  });
  return loginMutation;
}
